import React from "react"

export function PadlockIcon() {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="27" height="27" rx="13.5" fill="#EFEFEF" stroke="#EBEBEB" />
            <path
                d="M11.5556 12.3636H16.4444V10.4545C16.4444 9.75189 16.2057 9.15199 15.7283 8.65483C15.2509 8.15767 14.6748 7.90909 14 7.90909C13.3252 7.90909 12.7491 8.15767 12.2717 8.65483C11.7943 9.15199 11.5556 9.75189 11.5556 10.4545V12.3636ZM19.5 13.3182V19.0455C19.5 19.3106 19.4109 19.536 19.2326 19.7216C19.0544 19.9072 18.838 20 18.5833 20H9.41667C9.16204 20 8.9456 19.9072 8.76736 19.7216C8.58912 19.536 8.5 19.3106 8.5 19.0455V13.3182C8.5 13.053 8.58912 12.8277 8.76736 12.642C8.9456 12.4564 9.16204 12.3636 9.41667 12.3636H9.72222V10.4545C9.72222 9.23485 10.1424 8.1875 10.9826 7.3125C11.8229 6.4375 12.8287 6 14 6C15.1713 6 16.1771 6.4375 17.0174 7.3125C17.8576 8.1875 18.2778 9.23485 18.2778 10.4545V12.3636H18.5833C18.838 12.3636 19.0544 12.4564 19.2326 12.642C19.4109 12.8277 19.5 13.053 19.5 13.3182Z"
                fill="#90929E"
            />
        </svg>
    )
}
